import axiosInstance from "../../utils/axios";

export const getBlogs = async ({ sort = "", filter = "" }) => {
  let queryString = "";
  let queryStringFilter = "";

  switch (sort) {
    case "newest":
      queryString = `_sort=createdAt&_order=desc`;
      break;
    case "most_liked":
      queryString = `_sort=likes&_order=desc`;
      break;
    default:
      break;
  }

  queryStringFilter = filter === "saved" ? `isSaved=true` : "";

  const response = await axiosInstance.get(
    `/blogs?${queryString}&${queryStringFilter}`
  );

  return response?.data ?? [];
};
